import * as remoteAction from "../remoteAction";

export type GetLedgerActivityActionSuccess =
  remoteAction.MerchantRemoteResponse<
    "GET_CUSTOMER_LEDGER_ACTIVITY_SUCCESS",
    any
  >;
export type GetLedgerActivityActionFailure =
  remoteAction.MerchantRemoteResponse<
    "GET_CUSTOMER_LEDGER_ACTIVITY_FAILURE",
    any
  >;
export type GetLedgerActivityActionRequest =
  remoteAction.MerchantRemoteResponse<
    "GET_CUSTOMER_LEDGER_ACTIVITY_REQUEST",
    any
  >;

export interface GetLedgerActivityAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_CUSTOMER_LEDGER_ACTIVITY_REQUEST";
    success: "GET_CUSTOMER_LEDGER_ACTIVITY_SUCCESS";
    failure: "GET_CUSTOMER_LEDGER_ACTIVITY_FAILURE";
  };
}

export interface GetLedgerActivityActionParams {
  currency?: string;
}

function buildLedgerActivityUrl({
  currency,
}: GetLedgerActivityActionParams = {}): string {
  const baseUrl = "/analytics/loyalty-dashboard/customer-ledger-activity";
  const queryParams = [`pageSize=200`];

  if (currency) {
    queryParams.push(`currency=${encodeURIComponent(currency)}`);
  }

  return `${baseUrl}?${queryParams.join("&")}`;
}

export function getLedgerActivityAction(
  params?: GetLedgerActivityActionParams
): GetLedgerActivityAction {
  return {
    method: "GET",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_CUSTOMER_LEDGER_ACTIVITY_FAILURE",
      request: "GET_CUSTOMER_LEDGER_ACTIVITY_REQUEST",
      success: "GET_CUSTOMER_LEDGER_ACTIVITY_SUCCESS",
    },
    https: true,
    url: buildLedgerActivityUrl(params),
  };
}
